import DOMPurify from "dompurify";

/**
 * Sanitize text from Bedrock/API responses before rendering.
 * Defense-in-depth — output goes to <Textarea> (safe) but we strip HTML just in case.
 */
export function sanitizeResponse(text) {
  if (typeof text !== "string") return text;
  return DOMPurify.sanitize(text, { ALLOWED_TAGS: [], ALLOWED_ATTR: [] });
}
